@if (myself$ | async; as myself) {
  <div class="topbar-menu-wrapper" #topbarMenuWindow>
    <div class="main-user-menu">
      <button class="user-profile-menu-item" role="menuitem" (click)="goTo('/user-settings'); closeProfileMenu()">
        <mat-icon class="regular-text-color user-icon">person</mat-icon>
        <div class="user-info-wrapper">
          <div class="user-name">
            {{ myself.name }}
          </div>
          <div class="user-subtitle">
            {{ myself.email }}
          </div>
          @if (shouldShowOffice && myself.office?.addressCity) {
            <div class="user-subtitle">{{ myself.office.addressCity }}, {{ myself.office.addressStreet }}</div>
          }
          @if (shouldShowOffice && !myself.office?.addressCity) {
            <div id="office-not-assigned-description" class="sr-only">
              {{ 'COMMON.NOTIFICATION.CONTACT_ADMINISTRATOR_TO_ASSIGN_OFFICE' | translate }}
            </div>
          }
          @if (shouldShowOffice && !myself.office?.addressCity) {
            <div
              class="user-subtitle missing-assigned-office"
              [attr.aria-describedby]="'office-not-assigned-description'">
              {{ 'COMMON.LABEL.OFFICE_NOT_ASSIGNED' | translate }}
            </div>
          }
        </div>
      </button>
      @if (isAdministrator) {
        <button class="back-office-menu-item" role="menuitem" (click)="goTo('/back-office'); closeProfileMenu()">
          <mat-icon class="regular-text-color">settings</mat-icon>
          <span>{{ 'TOP_BAR.BACK_OFFICE' | translate }}</span>
        </button>
      }
      <button class="logout-menu-item" role="menuitem" (click)="logout(); closeProfileMenu()">
        <mat-icon class="regular-text-color">logout</mat-icon>
        <span>{{ 'USER_SETTINGS.LOGOUT' | translate }}</span>
      </button>
      <button class="version-text" role="menuitem" (click)="closeProfileMenu()" tabindex="-1">
        Version {{ version }}
      </button>
    </div>
  </div>
}
